import { render, staticRenderFns } from "./SelectAction.vue?vue&type=template&id=3b2ff72f&scoped=true"
import script from "./SelectAction.vue?vue&type=script&lang=js"
export * from "./SelectAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2ff72f",
  null
  
)

export default component.exports